// Centralized source of truth for all editable content on the MediSeller Pharmacy Platform
export const defaultSiteData = {
  contact: {
    whatsapp: '919876543210',
    email: 'info@mediseller.com',
    phone: '+919876543210'
  },
  header: {
    logoLabel: 'M',
    logoTitle: 'MediSeller',
    logoSubtitle: 'Affordable Life-Saving Medications',
    navLinks: [
      { label: 'Browse Diseases', target: '#categories' },
      { label: 'How It Works', target: '#how-it-works' },
      { label: 'Cost Savings', target: '#savings' },
      { label: 'Get Consultation', target: '#consultation' }
    ],
    ctaWhatsApp: 'WhatsApp',
    ctaWhatsAppTarget: 'whatsapp',
    ctaExpert: 'Get Expert Help',
    ctaExpertTarget: '#consultation'
  },
  hero: {
    badgeIcon: 'Award',
    badgeText: '45 Years Trusted | 50,000+ Patients Worldwide',
    title: 'Save Up to 75% on Life-Saving Medications',
    subtitle: 'Access authentic generic medications for Chronic & Terminal Diseases. Licensed pharmacy serving 30+ countries with express delivery.',
    primaryCTAText: 'Browse Medications',
    primaryCTAIcon: 'ArrowRight',
    primaryCTATarget: '#categories',
    secondaryCTAText: 'Upload Prescription',
    secondaryCTAIcon: 'Upload',
    secondaryCTATarget: '#consultation',
    stats: [
      { value: '45+', label: 'Years of Excellence', color: 'red' },
      { value: '50,000+', label: 'Patients Served', color: 'red' },
      { value: '72%', label: 'Average Savings', color: 'red' },
      { value: '98%', label: 'Satisfaction Rate', color: 'red' }
    ]
  },
  categories: {
    title: 'Browse by Disease Category',
    subtitle: 'Select your condition to view authentic generic medications with up to 75% savings',
    labels: {
      productsAvailable: 'Products Available:',
      avgSavings: 'Avg. Savings:',
      popularMeds: 'Popular medications:',
      viewMeds: 'View Medications',
      viewMedsTarget: 'whatsapp',
      terminalBadge: 'Terminal',
      chronicBadge: 'Chronic'
    },
    list: [
      {
        id: 'oncology',
        name: 'Oncology Medicines',
        type: 'terminal',
        icon: 'Activity',
        image: 'https://images.unsplash.com/photo-1579152276503-34e859b9649b',
        description: 'Affordable Cancer Treatment Medications from India',
        productCount: 30,
        avgSavings: '75%',
        commonMeds: ['Imatinib', 'Gefitinib', 'Erlotinib'],
        hero: {
          title: 'Oncology Medicines',
          subtitle: 'Affordable Cancer Treatment Medications From India',
          pills: ['30+ Medicines', 'Secure SSL', '7-21 Day Delivery']
        },
        support: {
          ctaTitle: "Can't Find Your Medication?",
          ctaSubtitle: "We can access 1,000+ cancer medications. Contact us if your medication is not in the list above.",
          faq: [
            { question: "Are these oncology medications authentic?", answer: "Yes, all our medications are sourced directly from licensed manufacturers like Cipla, Natco, and Hetero, ensuring 100% authenticity." },
            { question: "Why are the prices so much lower?", answer: "We provide high-quality generic alternatives which are chemically identical to patented versions but cost up to 90% less." },
            { question: "How long does shipping take?", answer: "Express temperature-controlled shipping typically takes 7-14 business days globally." }
          ],
          testimonials: [
            { id: 1, name: "John D.", condition: "Lung Cancer", medication: "Gefitinib", savings: "$2,500/mo", text: "Quality is top-notch. Saved a fortune." },
            { id: 2, name: "Maria S.", condition: "Breast Cancer", medication: "Letrozole", savings: "$400/mo", text: "Reliable service, always on time." }
          ]
        },
        subCategories: ['All', 'Targeted Therapy', 'Hormone Therapy', 'Chemotherapy'],
        medicines: [
          { id: 'onc-1', name: 'Imatinib 400mg', indication: 'Cancer: Chronic myeloid leukemia', strength: '400mg', packSize: '30 Tablets', originalPrice: '$1,200', ourPrice: '$45', discount: 'Save 75%', category: 'Targeted Therapy' },
          { id: 'onc-2', name: 'Gefitinib 250mg', indication: 'Cancer: Lung cancer', strength: '250mg', packSize: '30 Tablets', originalPrice: '$650', ourPrice: '$95', discount: 'Save 75%', category: 'Targeted Therapy' },
          { id: 'onc-3', name: 'Vandetanib 100mg', indication: 'Cancer: Thyroid cancer', strength: '100mg', packSize: '30 Tablets', originalPrice: '$2,100', ourPrice: '$150', discount: 'Save 75%', category: 'Targeted Therapy' },
          { id: 'onc-4', name: 'Erlotinib 150mg', indication: 'Cancer: Lung/Pancreatic cancer', strength: '150mg', packSize: '30 Tablets', originalPrice: '$850', ourPrice: '$85', discount: 'Save 75%', category: 'Targeted Therapy' },
          { id: 'onc-5', name: 'Sorafenib 200mg', indication: 'Cancer: Liver/Kidney cancer', strength: '200mg', packSize: '30 Tablets', originalPrice: '$1,450', ourPrice: '$180', discount: 'Save 75%', category: 'Targeted Therapy' },
          { id: 'onc-6', name: 'Sunitinib 50mg', indication: 'Cancer: Kidney cancer/GIST', strength: '50mg', packSize: '30 Capsules', originalPrice: '$2,500', ourPrice: '$210', discount: 'Save 75%', category: 'Targeted Therapy' },
          { id: 'onc-7', name: 'Lenalidomide 25mg', indication: 'Cancer: Multiple myeloma', strength: '25mg', packSize: '30 Capsules', originalPrice: '$3,800', ourPrice: '$280', discount: 'Save 75%', category: 'Targeted Therapy' },
          { id: 'onc-8', name: 'Letrozole 2.5mg', indication: 'Cancer: Breast cancer', strength: '2.5mg', packSize: '30 Tablets', originalPrice: '$120', ourPrice: '$12', discount: 'Save 75%', category: 'Hormone Therapy' },
          { id: 'onc-9', name: 'Tamoxifen 20mg', indication: 'Cancer: Breast cancer', strength: '20mg', packSize: '30 Tablets', originalPrice: '$80', ourPrice: '$8', discount: 'Save 75%', category: 'Hormone Therapy' },
          { id: 'onc-10', name: 'Anastrozole 1mg', indication: 'Cancer: Breast cancer', strength: '1mg', packSize: '30 Tablets', originalPrice: '$110', ourPrice: '$10', discount: 'Save 75%', category: 'Hormone Therapy' },
          { id: 'onc-11', name: 'Capecitabine 500mg', indication: 'Cancer: Colon/Rectal/Breast cancer', strength: '500mg', packSize: '100 Tablets', originalPrice: '$450', ourPrice: '$35', discount: 'Save 75%', category: 'Chemotherapy' },
          { id: 'onc-12', name: 'Temozolomide 250mg', indication: 'Cancer: Brain tumor', strength: '250mg', packSize: '5 Capsules', originalPrice: '$1,200', ourPrice: '$420', discount: 'Save 75%', category: 'Chemotherapy' },
          { id: 'onc-13', name: 'Pazopanib 400mg', indication: 'Cancer: Kidney cancer/ST Sarcoma', strength: '400mg', packSize: '30 Tablets', originalPrice: '$1,800', ourPrice: '$190', discount: 'Save 75%', category: 'Targeted Therapy' },
          { id: 'onc-14', name: 'Abiraterone 250mg', indication: 'Cancer: Prostate cancer', strength: '250mg', packSize: '120 Tablets', originalPrice: '$1,400', ourPrice: '$160', discount: 'Save 75%', category: 'Hormone Therapy' },
          { id: 'onc-15', name: 'Enzalutamide 40mg', indication: 'Cancer: Prostate cancer', strength: '40mg', packSize: '112 Capsules', originalPrice: '$3,200', ourPrice: '$380', discount: 'Save 75%', category: 'Hormone Therapy' },
          { id: 'onc-16', name: 'Bicalutamide 50mg', indication: 'Cancer: Prostate cancer', strength: '50mg', packSize: '30 Tablets', originalPrice: '$180', ourPrice: '$25', discount: 'Save 75%', category: 'Hormone Therapy' },
          { id: 'onc-17', name: 'Fulvestrant 250mg', indication: 'Cancer: Breast cancer', strength: '250mg', packSize: 'Prefilled Syringe', originalPrice: '$650', ourPrice: '$110', discount: 'Save 75%', category: 'Hormone Therapy' },
          { id: 'onc-18', name: 'Exemestane 25mg', indication: 'Cancer: Breast cancer', strength: '25mg', packSize: '30 Tablets', originalPrice: '$240', ourPrice: '$30', discount: 'Save 75%', category: 'Hormone Therapy' },
          { id: 'onc-19', name: 'Lapatinib 250mg', indication: 'Cancer: HER2+ Breast cancer', strength: '250mg', packSize: '70 Tablets', originalPrice: '$1,100', ourPrice: '$240', discount: 'Save 75%', category: 'Targeted Therapy' },
          { id: 'onc-20', name: 'Dasatinib 50mg', indication: 'Cancer: Leukemia', strength: '50mg', packSize: '60 Tablets', originalPrice: '$1,800', ourPrice: '$220', discount: 'Save 75%', category: 'Targeted Therapy' },
          { id: 'onc-21', name: 'Nilotinib 200mg', indication: 'Cancer: Leukemia', strength: '200mg', packSize: '28 Capsules', originalPrice: '$2,400', ourPrice: '$350', discount: 'Save 75%', category: 'Targeted Therapy' },
          { id: 'onc-22', name: 'Ponatinib 15mg', indication: 'Cancer: Leukemia', strength: '15mg', packSize: '30 Tablets', originalPrice: '$5,200', ourPrice: '$680', discount: 'Save 75%', category: 'Targeted Therapy' },
          { id: 'onc-23', name: 'Afatinib 40mg', indication: 'Cancer: Lung cancer', strength: '40mg', packSize: '28 Tablets', originalPrice: '$2,100', ourPrice: '$320', discount: 'Save 75%', category: 'Targeted Therapy' },
          { id: 'onc-24', name: 'Cabozantinib 60mg', indication: 'Cancer: Kidney/Thyroid/Liver cancer', strength: '60mg', packSize: '30 Tablets', originalPrice: '$3,800', ourPrice: '$450', discount: 'Save 75%', category: 'Targeted Therapy' },
          { id: 'onc-25', name: 'Axitinib 5mg', indication: 'Cancer: Kidney cancer', strength: '5mg', packSize: '28 Tablets', originalPrice: '$850', ourPrice: '$140', discount: 'Save 75%', category: 'Targeted Therapy' },
          { id: 'onc-26', name: 'Regorafenib 40mg', indication: 'Cancer: Colorectal/GIST/Liver cancer', strength: '40mg', packSize: '28 Tablets', originalPrice: '$1,650', ourPrice: '$260', discount: 'Save 75%', category: 'Targeted Therapy' },
          { id: 'onc-27', name: 'Lenvatinib 10mg', indication: 'Cancer: Thyroid/Kidney/Liver cancer', strength: '10mg', packSize: '20 Capsules', originalPrice: '$2,200', ourPrice: '$290', discount: 'Save 75%', category: 'Targeted Therapy' },
          { id: 'onc-28', name: 'Everolimus 10mg', indication: 'Cancer: Kidney/Breast/Neuroendocrine', strength: '10mg', packSize: '10 Tablets', originalPrice: '$1,450', ourPrice: '$180', discount: 'Save 75%', category: 'Targeted Therapy' },
          { id: 'onc-29', name: 'Palbociclib 125mg', indication: 'Cancer: Breast cancer', strength: '125mg', packSize: '21 Capsules', originalPrice: '$2,800', ourPrice: '$420', discount: 'Save 75%', category: 'Targeted Therapy' },
          { id: 'onc-30', name: 'Ribociclib 200mg', indication: 'Cancer: Breast cancer', strength: '200mg', packSize: '21 Tablets', originalPrice: '$2,800', ourPrice: '$450', discount: 'Save 75%', category: 'Targeted Therapy' }
        ]
      },
      {
        id: 'hepatitis',
        name: 'Hepatitis & Liver Diseases',
        type: 'chronic',
        icon: 'Heart',
        image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef',
        description: 'Hepatitis B, C treatment and liver disease management medications',
        productCount: 45,
        avgSavings: '70%',
        commonMeds: ['Sofosbuvir', 'Tenofovir', 'Entecavir']
      },
      {
        id: 'hiv',
        name: 'HIV/AIDS',
        type: 'chronic',
        icon: 'Shield',
        image: 'https://images.unsplash.com/photo-1584515933487-779824d29309',
        description: 'Antiretroviral therapy and HIV management medications',
        productCount: 52,
        avgSavings: '75%',
        commonMeds: ['TDFFTC', 'Dolutegravir', 'Efavirenz']
      },
      {
        id: 'cardiovascular',
        name: 'Cardiovascular Diseases',
        type: 'chronic',
        icon: 'HeartPulse',
        image: 'https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd',
        description: 'Heart disease, hypertension, and cholesterol management',
        productCount: 120,
        avgSavings: '65%',
        commonMeds: ['Atorvastatin', 'Clopidogrel', 'Enalapril']
      },
      {
        id: 'diabetes',
        name: 'Diabetes',
        type: 'chronic',
        icon: 'Droplet',
        image: 'https://images.unsplash.com/photo-1615485500704-8e990f9900f7',
        description: 'Type 1 & 2 diabetes management including insulin and oral medications',
        productCount: 150,
        avgSavings: '70%',
        commonMeds: ['Metformin', 'Insulin', 'Empagliflozin']
      },
      {
        id: 'nephrology',
        name: 'Kidney Diseases',
        type: 'chronic',
        icon: 'Pill',
        image: 'https://images.unsplash.com/photo-1631549916768-4119b2e5f926',
        description: 'Chronic kidney disease, dialysis, and renal care medications',
        productCount: 75,
        avgSavings: '68%',
        commonMeds: ['Epoetin', 'Sevelamer', 'Calcitriol']
      },
      {
        id: 'respiratory',
        name: 'Respiratory Diseases',
        type: 'chronic',
        icon: 'Wind',
        image: 'https://images.unsplash.com/photo-1628595351029-c2bf17511435',
        description: 'Asthma, COPD, and chronic respiratory condition management',
        productCount: 85,
        avgSavings: '65%',
        commonMeds: ['Budesonide', 'Tiotropium', 'Montelukast'],
        subCategories: ['All', 'Inhaler', 'Oral', 'Injection'],
        medicines: [
          {
            id: 'res-1',
            name: 'Beclomethasone Inhaler',
            indication: 'Asthma, COPD',
            strength: '200 mcg',
            packSize: '200 doses',
            originalPrice: '₹1,280',
            ourPrice: '₹640',
            discount: '50% Off',
            category: 'Inhaler'
          },
          {
            id: 'res-2',
            name: 'Tiotropium Bromide',
            indication: 'COPD, Emphysema',
            strength: '18 mcg',
            packSize: '30 capsules',
            originalPrice: '₹2,450',
            ourPrice: '₹950',
            discount: '61% Off',
            category: 'Inhaler'
          },
          {
            id: 'res-3',
            name: 'Montelukast Sodium',
            indication: 'Allergies, Asthma',
            strength: '10 mg',
            packSize: '30 tablets',
            originalPrice: '₹980',
            ourPrice: '₹420',
            discount: '57% Off',
            category: 'Oral'
          }
        ]
      },
      {
        id: 'rheumatology',
        name: 'Rheumatology',
        type: 'chronic',
        icon: 'Bone',
        description: 'Rheumatoid arthritis, lupus, and autoimmune disease treatments',
        productCount: 90,
        avgSavings: '76%',
        commonMeds: ['Methotrexate', 'Hydroxychloroquine', 'Adalimumab']
      },
      {
        id: 'neurology',
        name: 'Neurological Disorders',
        type: 'chronic',
        icon: 'Brain',
        description: 'Epilepsy, Parkinsons, MS, and neurological condition management',
        productCount: 100,
        avgSavings: '71%',
        commonMeds: ['Levetiracetam', 'Levodopa', 'Glatiramer']
      },
      {
        id: 'transplant',
        name: 'Transplant Medications',
        type: 'chronic',
        icon: 'Syringe',
        description: 'Immunosuppressants for organ transplant patients',
        productCount: 65,
        avgSavings: '74%',
        commonMeds: ['Tacrolimus', 'Mycophenolate', 'Cyclosporine']
      }
    ]
  },
  savings: {
    badgeIcon: 'TrendingDown',
    badgeText: 'Real Cost Comparisons',
    title: 'US Patented vs Indian Generic',
    subtitle: 'See exactly how much you can save on your medications with our authentic generic alternatives',
    labels: {
      medicationCol: 'Medication',
      usPriceCol: 'US Price',
      perMonthText: 'per month',
      ourPriceCol: 'Our Price',
      youSaveCol: 'You Save',
      annualText: 'Annual: '
    },
    list: [
      {
        category: 'Hepatitis C',
        medication: 'Sofosbuvir 400mg',
        usPrice: '$28,000',
        indianPrice: '$2,160',
        savings: '$25,840',
        savingsPercent: '92%',
        annualUSSavings: '$25,840'
      },
      {
        category: 'HIV',
        medication: 'TDF/FTC Combination',
        usPrice: '$2,200',
        indianPrice: '$540',
        savings: '$1,660',
        savingsPercent: '75%',
        annualUSSavings: '$19,920'
      },
      {
        category: 'Diabetes',
        medication: 'Insulin Glargine',
        usPrice: '$6,000',
        indianPrice: '$1,800',
        savings: '$4,200',
        savingsPercent: '70%',
        annualUSSavings: '$50,400'
      },
      {
        category: 'Cardiovascular',
        medication: 'Clopidogrel 75mg',
        usPrice: '$480',
        indianPrice: '$120',
        savings: '$360',
        savingsPercent: '75%',
        annualUSSavings: '$4,320'
      }
    ],
    ctaTitle: 'Ready to Start Saving?',
    ctaSubtitle: 'Upload your prescription and get a personalized cost comparison',
    ctaButton: 'Get Your Quote Now',
    ctaTarget: '#consultation'
  },
  testimonials: {
    title: 'Real Patient Stories',
    subtitle: 'Hear from patients who transformed their lives with affordable, authentic medications',
    labels: {
      verifiedText: 'Verified',
      conditionLabel: 'Condition',
      medicationLabel: 'Medication',
      totalSavingsLabel: 'Total Savings',
      treatmentDurationLabel: 'Treatment Duration'
    },
    list: [
      {
        id: 2,
        name: 'Sarah Mitchell',
        age: 45,
        condition: 'Hepatitis C',
        country: 'United Kingdom',
        medication: 'Sofosbuvir + Velpatasvir',
        treatmentDuration: '12 weeks',
        savings: '$42,000',
        rating: 5,
        verified: true,
        image: 'https://i.pravatar.cc/150?img=5',
        testimonial: 'Hepatitis C treatment in the UK was going to cost me £84,000. Through MediSeller, I got the complete 12-week course for £3,200. I\'m now cured and debt-free. The medications were authentic, properly packaged, and delivered quickly. Life-changing service!'
      },
      {
        id: 3,
        name: 'Michael Chen',
        age: 42,
        condition: 'HIV/AIDS',
        country: 'Canada',
        medication: 'Antiretroviral Therapy',
        treatmentDuration: 'Ongoing (4 years)',
        savings: '$80,000+',
        rating: 5,
        verified: true,
        image: 'https://i.pravatar.cc/150?img=33',
        testimonial: 'Managing HIV in Canada costs $2,200/month for medications. MediSeller provides the same quality generics for $540/month. Over 4 years, I\'ve saved $80,000. My viral load is undetectable, and I\'m living a normal, healthy life without financial stress.'
      }
    ]
  },
  howItWorks: {
    title: 'How It Works',
    subtitle: 'Simple, secure, and transparent process from prescription to delivery',
    steps: [
      { step: 1, title: 'Select Disease Category', description: 'Browse our comprehensive disease categories and select your condition', icon: 'Search', action: 'Browse Categories' },
      { step: 2, title: 'Upload Prescription', description: 'Upload your valid prescription or medical documents securely', icon: 'Upload', action: 'Upload Documents' },
      { step: 3, title: 'Expert Consultation', description: 'Our licensed pharmacists review and verify your requirements', icon: 'UserCheck', action: 'Get Consultation' },
      { step: 4, title: 'Receive Quote', description: 'Get detailed pricing with cost comparison to local prices', icon: 'DollarSign', action: 'View Pricing' },
      { step: 5, title: 'Secure Payment', description: 'Pay securely through our certified payment gateway', icon: 'CreditCard', action: 'Make Payment' },
      { step: 6, title: 'Quality Assurance', description: 'Medications are quality-checked and prepared for shipment', icon: 'ShieldCheck', action: 'Track Order' },
      { step: 7, title: 'Express Delivery', description: 'Receive medications via temperature-controlled express shipping', icon: 'Plane', action: 'Track Package' }
    ]
  },
  legacy: {
    title: '45 Years of Trust & Excellence',
    subtitle: 'Our journey from 1980 to serving 50,000+ patients globally',
    timeline: [
      { year: 1980, event: 'MediSeller founded in Mumbai, India' },
      { year: 1995, event: 'Started international export services' },
      { year: 2005, event: 'Expanded to 20+ countries' },
      { year: 2010, event: 'Specialized in chronic & terminal disease medications' },
      { year: 2015, event: 'Launched online consultation services' },
      { year: 2020, event: 'Served 50,000+ patients globally' },
      { year: 2025, event: '45 years of trusted pharmaceutical services' }
    ],
    certificationsTitle: 'Certifications',
    certifications: [
      'WHO-GMP Certified',
      'ISO 9001:2015',
      'FDA Recognized',
      'Licensed Exporter',
      'Cold Chain Certified'
    ],
    partnershipsTitle: 'Trusted Partnerships',
    partnerships: [
      'Cipla', 'Natco Pharma', 'Dr. Reddys', 'Sun Pharma',
      'Biocon', 'Lupin', 'Aurobindo', 'Zydus Cadila'
    ]
  },
  consultation: {
    title: 'Upload Prescription & Get Expert Consultation',
    subtitle: 'Our licensed pharmacists will review your prescription and provide personalized guidance',
    formTitle: 'Request Consultation',
    expertsTitle: 'Our Expert Pharmacists',
    experts: [
      { name: 'Dr. Rajesh Kumar', qualification: 'PharmD, Clinical Pharmacist', experience: '18 years', specialty: 'Chronic Disease Management' },
      { name: 'Dr. Priya Sharma', qualification: 'PharmD, Hospital Pharmacist', experience: '15 years', specialty: 'Cardiovascular & Diabetes' },
      { name: 'Dr. Amit Patel', qualification: 'PharmD, Specialty Pharmacist', experience: '20 years', specialty: 'HIV/AIDS & Infectious Diseases' }
    ],
    benefitsTitle: 'Why Consult Our Experts?',
    benefits: [
      'Medication Verification',
      'Dosage Guidance',
      'Treatment Planning',
      'Cost Comparison',
      'Prescription Review',
      'Alternative Options'
    ]
  },
  payment: {
    title: 'Secure Payment Options',
    subtitle: 'Multiple payment methods with bank-level security',
    methodsTitle: 'Payment Methods',
    methods: ['Credit Card', 'Debit Card', 'Wire Transfer', 'PayPal', 'Bank Transfer'],
    securityTitle: 'Security Features',
    security: ['PCI DSS Compliant', '256-bit SSL Encryption', '3D Secure Authentication'],
    additionalTitle: 'Additional Features',
    additional: [
      'Secure checkout process',
      'Multiple currency support',
      'Installment payment options',
      'Refund & cancellation policy',
      'Transaction history & receipts'
    ],
    certText: 'PCI DSS Level 1 Certified Payment Gateway',
    certDesc: 'Your payment information is encrypted and secure. We never store your card details.'
  },
  finalCTA: {
    title: 'Start Your Journey to Affordable Healthcare Today',
    subtitle: 'Join 50,000+ patients who\'ve saved millions on life-saving medications',
    primaryButton: 'Browse Medications',
    primaryButtonTarget: '#categories',
    secondaryButton: 'Chat on WhatsApp',
    secondaryButtonTarget: 'whatsapp'
  },
  footer: {
    aboutTitle: 'MediSeller',
    aboutSubtitle: 'Since 1980',
    aboutDesc: 'Trusted online pharmacy providing authentic generic medications for chronic and terminal diseases.',
    quickLinksTitle: 'Quick Links',
    contactTitle: 'Contact Us',
    whatsappStatus: 'WhatsApp available',
    quickContactTitle: 'Quick Contact',
    quickContactButton: 'WhatsApp',
    quickContactButtonTarget: 'whatsapp',
    quickContactDesc: 'Available 24/7 for consultations',
    copyright: '© 2025 MediSeller Pharmacy. All rights reserved.'
  },
  adminAuth: {
    username: 'admin',
    password: 'password123'
  },
  version: '1.0.3'
};
